/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_Notes_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose how to insert music note symbols into your text" |
*
* @param {Music_Notes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes_description = /** @type {((inputs?: Music_Notes_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_Notes_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez comment insérer les symboles de notes de musique dans votre texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie aus, wie Musiknotensymbole in Ihren Text eingefügt werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli come inserire i simboli delle note musicali nel tuo testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите способ вставки символов музыкальных нот в текст.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elige cómo insertar símbolos de notas musicales en tu texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择如何在文本中插入音符符号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストに音符記号を挿入する方法を選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने टेक्स्ट में संगीत नोट प्रतीकों को कैसे शामिल करना है, यह चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha como inserir símbolos de notas musicais no seu texto.")
	return /** @type {LocalizedString} */ ("Choose how to insert music note symbols into your text")
});